import numberRange from './positiveInt'

const install = function(Vue) {
  Vue.directive('number-range', numberRange)
}

if (window.Vue) {
  window['number-range'] = numberRange
  Vue.use(install); // eslint-disable-line
}

numberRange.install = install
export default numberRange
